import { render, staticRenderFns } from "./ZoomableImage.vue?vue&type=template&id=e12352e4"
import script from "./ZoomableImage.vue?vue&type=script&lang=js"
export * from "./ZoomableImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports